export default __webpack_public_path__ + "static/media/kuchnia4.b183dda4.jpg";